// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"e936fa24","703":"55aa9ebc","787":"0359919a"}[chunkId] + ".chunk.js";
};